import Tooltip from '@material-ui/core/Tooltip';
import IconButton from "@material-ui/core/IconButton";
import React from 'react';
import GetAppIcon from '@material-ui/icons/GetApp';
import { Menu, MenuItem } from '@material-ui/core';
import dayjs from 'dayjs';

function convertTZ(date, tzString) {
	return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tzString }));
}

const CSVDialog = ({ columns, rows, additionalData, filename }) => {

	const [anchorEl, setAnchorEl] = React.useState(null);

	const open = Boolean(anchorEl);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const exportCSV = (timezone) => {
		let csv = [];
		const csv_columns = columns.map((item) => {
			return item.headerName;
		});
		const csv_rows = rows.map((item) => {
			let row = columns.map((row) => {
				if (row.type === 'date') return `"${new Date(item[row.field]).toLocaleString('en-AU', { timeZone: timezone }) || ''} (${timezone})"`;
				if (row.io) return `"${String(item.io[row.field]) || ''}"`;
				return `"${String(item[row.field]) || ''}"`;
			});
			return row.join(',');
		});
		if (additionalData) {
			csv.push(additionalData.join(','));
		}
		csv.push(csv_columns.join(','));
		csv.push(csv_rows.join('\r'));
		csv = csv.join('\n');
		handleClose();
		downloadCSV(csv, filename);
	}

	const downloadCSV = (csv, filename) => {
		var csvFile;
		var downloadLink;

		csvFile = new Blob([csv], { type: "text/csv" });
		downloadLink = document.createElement("a");
		downloadLink.download = filename;
		downloadLink.href = window.URL.createObjectURL(csvFile);
		downloadLink.style.display = "none";
		document.body.appendChild(downloadLink);
		downloadLink.click();
	}

	return (
		<>
			<Tooltip title="Export as CSV">
				<IconButton onClick={handleClick}>
					<GetAppIcon />
				</IconButton>
			</Tooltip>
			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					'aria-labelledby': 'basic-button',
				}}
			>
				<MenuItem disabled>Pick a Time Zone</MenuItem>
				<MenuItem onClick={() => exportCSV('Australia/Adelaide')}>SA</MenuItem>
				<MenuItem onClick={() => exportCSV('Australia/Sydney')}>NSW</MenuItem>
				<MenuItem onClick={() => exportCSV('Australia/Melbourne')}>VIC</MenuItem>
				<MenuItem onClick={() => exportCSV('Australia/Hobart')}>TAS</MenuItem>
				<MenuItem onClick={() => exportCSV('Australia/Brisbane')}>QLD</MenuItem>
				<MenuItem onClick={() => exportCSV('Australia/Perth')}>WA</MenuItem>
				<MenuItem onClick={() => exportCSV('Australia/Darwin')}>NT</MenuItem>
				<MenuItem onClick={() => exportCSV('Australia/Canberra')}>ACT</MenuItem>
			</Menu>
		</>
	)
}

CSVDialog.propTypes = {
}

export default CSVDialog
